import { FETCH_NEEDS_ASSESSMENT_RESULTS, FETCH_NEEDS_ASSESSMENT_RESULTS_SUCCESS, FETCH_NEEDS_ASSESSMENT_RESULTS_ERROR } from "../actions/needsAssessmentActions";

const initialState = {
  results: { answers: [] },
  selectedCommunityId: null,
  isLoading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NEEDS_ASSESSMENT_RESULTS:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_NEEDS_ASSESSMENT_RESULTS_SUCCESS:
      return setResults(state, action);
    case FETCH_NEEDS_ASSESSMENT_RESULTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
  }
  return state;
};

const setResults = (state, action) => {
  const { results = {} } = action;
  return {
    ...state,
    results,
    selectedCommunityId: action.selectedCommunityId,
    isLoading: false,
  };
};



// WEBPACK FOOTER //
// ./app/assets/flux/reducers/needsAssessmentResults.js